import React, { useRef, useState, useEffect } from "react";
import { uploadFile } from "utlis/utils";
import UploadedFileName from "components/UploadFileName";
import { Ptag } from "components/core/fonts";
import download from "assets/svgs/downloadNew.svg";
// import UploadIcon from "assets/images/upload.png";
import UploadIcon from "assets/svgs2026/uploadFileIcon.svg";
import DownloadIcon from "assets/images/downloadcsv.png"
import {
  Error,
  UploadButton,
  UploadWrapper,
  Label,
  DownloadButton,
  UploadButtonGlassEffect,
} from "./styles";
import http from "services/httpService";
import { BaseSnackbar } from "components/core";
import GlassWrapper from "components/GlassWrapper";
import { Download } from "components/core/BaseTable/styles";

const FileFormat = {
  PolicyNumber:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement.xlsx",
  CdLedger:
    "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/CD_Ledger_Format.xlsx",
  FlexEmployeeSheet:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Flex+Employee+sheet.xlsx",
  FlexRateChart:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Flex+Rate+Chart.xlsx",
  MasterEmployeeSheet:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Master%2BEmployee%2BSheet+%2BNew.xlsx",
  FlexEmployeeSheet:
    "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/Data+Collection+Sheet+for+Flex+2.xlsx",
  UhidUploadSheet:
    "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/inception_uhid_template.xlsx",
  UHID_sheet:
    "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/UHID_upload_sheet_.xlsx",
};

const DownloadFormat = {
  health_insurance:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  GMC: "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  GMC_M:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  GPA: "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GPA.xlsx",
  personal_accident:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GPA.xlsx",
  GTL: "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GTL.xlsx",
  term_life:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GTL.xlsx",
  opd_cover:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  critical_illness:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  health_checkup:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  mandatory_top_up_health:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  top_up_health:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  parental_cover:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  health_insurance_parents:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
  health_insurance_parents_in_laws:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement+GHI+format.xlsx",
};

const UploadFile = ({
  label,
  text,
  uploadButtonText="Download Excel Format",
  showError,
  onSelect,
  type,
  format,
  sampleFile,
  fileDataNeed,
  existingFileName,
  productType,
  customApi,
  customPostData,
  showProgressBar = true,
  customData,
  isDisabled,
  onDownload,
  getFile,
  description,
  fileName,
  headerMargin,
  glassButtonEffect=false,
}) => {
  const inputRef = useRef();
  const [policyDocFile, setPolicyDocFile] = useState({ name: "", size: "" });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [file, setFile] = useState(null);
  useEffect(() => {
    setFile(existingFileName);
    setPolicyDocFile({ name: existingFileName, size: 0 });
  }, [existingFileName]);
  const acceptFile = {
    pdfXl:
      "application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    pdf: "application/pdf",
    excel:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
  };
  const DownloadExcel = () => {
    if (onDownload) {
      onDownload();
      return;
    }
    let url = "";
    if (
      sampleFile == "CdLedger" ||
      sampleFile == "FlexRateChart" ||
      sampleFile == "FlexEmployeeSheet" ||
      sampleFile == "MasterEmployeeSheet" ||
      sampleFile == "UhidUploadSheet" ||
      sampleFile == "UHID_sheet"
    ) {
      url = FileFormat[sampleFile];
    } else {
      url = DownloadFormat[productType];
    }
    window.open(url, true);
  };
  const storeFile = (file) => {
    setFile(file);
    fileName && fileName(file?.name);
    fileDataNeed && fileDataNeed(file);
    setPolicyDocFile({ name: file.name, size: file.size });
  };
  const onChange = async (e) => {
    if (customApi && customPostData && typeof customPostData == "undefined") {
      alert("Please enter premium based on each dependent's age and premium.");
      return;
    }
    const formData = new FormData();
    let targetedFile = e.currentTarget.files[0];
    getFile && getFile(targetedFile);
    formData.append("file_details", targetedFile);

    if (onSelect) {
      const fileId = await uploadFile(targetedFile, type);
      targetedFile && storeFile(targetedFile);
      onSelect(fileId);
    }
    if (customApi) {
      try {
        const options = {
          "Content-Type": "multipart/form-data",
        };
        formData.append("dependent_wise_premium_calculation", customPostData);
        const { data } = await http.post(customApi, formData, {
          headers: options,
        });
        customData(data, targetedFile);
        targetedFile && storeFile(targetedFile);
      } catch (err) {
        console.log(err.response);
        let errorMessage = "";
        if (err?.response?.data && typeof err?.response?.data === "string") {
          errorMessage = err.response.data;
        }
        setSnackbarMessage(errorMessage);
        setShowSnackbar(true);
      }
    } else {
      targetedFile && storeFile(targetedFile);
    }
  };
  const resetFile = () => { 
    setFile(null);
    onSelect && onSelect(null);
    customData && customData(null, null);
  };

  const downloadButtonJSX = (download, uploadButtonText) => {
    if (glassButtonEffect) {
      return (
        <>
          <Download
            id="business_uploadexcel_download_button"
            onClick={() => DownloadExcel()}
            style={{
              // width: "280px",
              whiteSpace: "nowrap",
              marginRight: "0px",
              display: "flex",
              gap: "15px"
            }}
          >
            <span className="mis-download-div-text">
              {uploadButtonText}
            </span>
            <GlassWrapper className="glass-xl glass-wrapper-no-width">
              <img
                src={DownloadIcon}
                width="18px"
                height="18px"
                style={{ margin: "4px", padding: "1px" }}
              />
            </GlassWrapper>
          </Download>
        </>
      )
    } else {
      return (<>
        <DownloadButton
          id="business_uploadexcel_download_button"
          onClick={() => DownloadExcel()}
        >
          <img
            style={{ marginRight: "6px", height: "18px", width: "16px" }}
            src={download}
            height="20px"
            width="17px"
          />
          <Ptag
            textAlign="center"
            fontSize="14px"
            fontWeight="600"
            letterHeight="19px"
            color="white"
            fontFamily="Montserrat"
          >
            {uploadButtonText}
          </Ptag>
        </DownloadButton>
      </>)
    }
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            margin: `${headerMargin ? headerMargin : " 36px 0 18px 0"}`,
          }}
        >
          <Label>{label}</Label>
          {description && (
            <Ptag fontSize="14px" fontWeight="400" marginTop="6px">
              {description}
            </Ptag>
          )}
        </div>
        {!!sampleFile && downloadButtonJSX(download, uploadButtonText)}
      </div>
      <UploadWrapper>
        <UploadButtonGlassEffect
          onClick={() => inputRef.current.click()}
          style={{
            cursor: isDisabled ? "" : "pointer",
          }}
        >
          <img
            style={{ marginRight: "6px", height: "16px", width: "14px" }}
            src={UploadIcon}
            height="18px"
            width="18px"
          />
          <input
            ref={inputRef}
            type="file"
            accept={acceptFile[format]}
            onChange={onChange}
            disabled={isDisabled}
          />
          <Ptag fontSize="14px" fontWeight="600" letterHeight="19px" color="rgba(0, 0, 0, 1)" fontFamily="Montserrat">
            {text}
          </Ptag>
        </UploadButtonGlassEffect>
        {showError && !file && <Error>  
        *Required  </Error>   }
        {showProgressBar && file && <UploadedFileName file={policyDocFile} onClick={resetFile} />}
        {/* <Ptag>{file && file.name}</Ptag> */}
      </UploadWrapper>
      <BaseSnackbar
        open={showSnackbar}
        handleClose={() => setShowSnackbar(false)}
        message={snackbarMessage}
        type="error"
      />
    </>
  );
};

export default UploadFile;
